import styled, { css } from 'styled-components';
import { IMAGE_SIZE } from '@services/images/constants';

import Card from '@components/Card';

const SwimlaneItem = styled(Card)`
  padding: 0;
  flex-direction: column;
  cursor: pointer;
  margin: ${({ theme }) => theme.spacing(6, 6, 0, 0)};
  ${({ size, contained }) =>
    size !== IMAGE_SIZE.BIG &&
    !contained &&
    css`
      @media only screen and (min-width: 550px) {
        width: 25%;
      }
    `}
`;

export default SwimlaneItem;
